<div class="toolbar">
  <label>Search documents
    <input type="search" class="form-control" placeholder="Document, applicant or reference" [ngModel]="search()" (ngModelChange)="search.set($event); page.set(1)">
  </label>
  <label>Status
    <select class="form-control" [ngModel]="status()" (ngModelChange)="status.set($event); page.set(1)">
      <option>All</option><option>Pending</option><option>Approved</option><option>Rejected</option>
    </select>
  </label>
  <button type="button" class="btn btn-secondary" (click)="load()" [disabled]="loading() || busy()">Refresh</button>
</div>
@if (error()) { <p class="alert alert-danger" role="alert">{{ error() }}</p> }
@if (message()) { <p class="alert alert-success" role="status">{{ message() }}</p> }
@if (loading()) {
  <p role="status">Loading documents…</p>
} @else if (documents().length || !error()) {
  <p><strong>{{ pendingCount() }}</strong> documents require verification.</p>
  <div class="table-scroll">
    <table>
      <thead><tr><th>Document</th><th>Applicant</th><th>Application</th><th>Status</th><th>Actions</th></tr></thead>
      <tbody>
        @for (document of pageDocuments(); track document.id) {
          <tr>
            <td><strong>{{ document.name }}</strong><small>{{ document.documentType }}</small><small>Uploaded {{ document.uploadedDate | date: 'dd MMM yyyy, HH:mm' }}</small></td>
            <td>{{ document.applicantName }}</td>
            <td>{{ document.referenceNumber }}<small>{{ document.scholarshipTitle }}</small></td>
            <td><span class="status" [class.approved]="document.reviewStatus === 'Approved'" [class.rejected]="document.reviewStatus === 'Rejected'">{{ document.reviewStatus }}</span>
              @if (document.reviewedDate) { <small>{{ document.reviewedDate | date: 'dd MMM yyyy, HH:mm' }}</small> }
            </td>
            <td><div class="actions">
              <button type="button" class="btn btn-success" (click)="review(document, 'Approved')" [disabled]="busy() || document.reviewStatus === 'Approved'" [attr.aria-label]="'Approve ' + document.name">Approve</button>
              <button type="button" class="btn btn-danger" (click)="review(document, 'Rejected')" [disabled]="busy() || document.reviewStatus === 'Rejected'" [attr.aria-label]="'Reject ' + document.name">Reject</button>
              <button type="button" class="btn btn-secondary" (click)="download(document)" [disabled]="downloading() !== null" [attr.aria-label]="'Download ' + document.name">{{ downloading() === document.id ? 'Downloading…' : 'Download' }}</button>
            </div></td>
          </tr>
        } @empty {
          <tr><td colspan="5">{{ documents().length ? 'No documents match your filters.' : 'No application documents are available.' }}</td></tr>
        }
      </tbody>
    </table>
  </div>
  <app-pagination [currentPage]="page()" [totalPages]="totalPages()" [totalItems]="filtered().length" [showingFrom]="showingFrom()" [showingTo]="showingTo()" itemLabel="documents" (pageChange)="page.set($event)"></app-pagination>
}
